import { Platform } from 'react-native';
import { PLATFORM_TYPES } from '../constants/UIConstants';

export const isWeb = Platform.OS === PLATFORM_TYPES.web.key;
export const isAndroid = Platform.OS === PLATFORM_TYPES.android.key;
export const isIos = Platform.OS === PLATFORM_TYPES.ios.key;